<div class="esri-widget basemap-toggle { isReady ? "visible" : ""}" 
  bind:this={basemapWidget}
  on:click={toggleBasemap}>
  <img src={currentImageUrl} alt="Basemap">
  <span>{currentThumbnailName}</span>
</div>



<script>
import { loadModules, setDefaultOptions } from "esri-loader";
import store from "../../state";
import utils from "../../utils";
utils.isIE() && setDefaultOptions({ version: "4.12" });
let mapViewSvc;
let mapView;
let basemapWidget;
let basemapToggleViewModel;
let basemapToggleViewConstructor;
let currentImageUrl;
let currentThumbnailName;
let isReady = false;
const unsubscribe = store.subscribe(state => {
    if (state.mapViewService && state.mapViewService.isReady()) {
        mapViewSvc = state.mapViewService;
        mapView = mapViewSvc.getMapView();
        loadBaseMap();
        unsubscribe();
    }
});
function loadBaseMap() {
    loadModules([
        "esri/widgets/BasemapToggle/BasemapToggleViewModel",
        "esri/Basemap",
        "esri/layers/TileLayer"
    ]).then(([BasemapToggleViewModel, Basemap, TileLayer]) => {
        basemapToggleViewConstructor = BasemapToggleViewModel;
        basemapToggleViewModel = new BasemapToggleViewModel({
            view: mapView,
            nextBasemap: new Basemap({
                baseLayers: [
                    new TileLayer({
                        url: "http://maps.six.nsw.gov.au/arcgis/rest/services/public/NSW_Imagery/MapServer"
                    })
                ],
                thumbnailUrl: "https://js.arcgis.com/4.12/esri/images/basemap/hybrid.jpg"
            })
        });
        updateBasemapThumbnail();
        mapView === null || mapView === void 0 ? void 0 : mapView.ui.add([
            {
                component: basemapWidget,
                position: "bottom-left",
                index: 0
            }
        ]);
        isReady = true;
    });
}
function toggleBasemap() {
    basemapToggleViewModel.toggle();
    updateBasemapThumbnail();
}
function updateBasemapThumbnail() {
    currentImageUrl = basemapToggleViewConstructor.getThumbnailUrl(basemapToggleViewModel.nextBasemap);
    currentThumbnailName =
        basemapToggleViewModel.activeBasemap.title === "Topographic"
            ? "Satellite"
            : "";
}
</script>


<style>.basemap-toggle{width:48px;height:48px;border-radius:10px;border:2px solid #ccc;box-shadow:0 2px 4px 0 rgba(0,0,0,.5);cursor:pointer;color:#fff;position:relative;visibility:hidden;pointer-events:auto;display:flex;justify-content:center;align-items:flex-end;margin-right:10px}.basemap-toggle span{font-size:10px;z-index:1}.basemap-toggle.visible{visibility:visible}.basemap-toggle img{position:absolute;top:0;left:0;width:100%;height:100%;border-radius:6px}</style>
